import "./App.css";
import Privacy from "./pages";

function App() {
  return (
    // <div className="App">
    <Privacy />
    // </div>
  );
}

export default App;
